/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    require('@popperjs/core');
    window.$ = window.jQuery = require('jquery');
    window.$.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': window.$('meta[name="csrf-token"]').attr('content')
        },
        xhrFields: {
            withCredentials: true
        }
    });
    $.fn.switchValue = function(forceValue) {
        var dataAttribute = 'value-toggle';
        this.filter( "input[data-" + dataAttribute + "]"  ).each(function() {
            var oldValue = $(this).val();
            var newValue = $(this).data(dataAttribute);
            if (typeof forceValue !== 'undefined' && forceValue == oldValue) {
                return;
            }
            $(this).data(dataAttribute, oldValue);
            $(this).val(newValue)
        });
        return this;
    };

    require('bootstrap');
    window.Modal = require('bootstrap').Modal;
    require('waypoints/lib/jquery.waypoints');
    require('waypoints/lib/shortcuts/inview');
    window.tns = require('tiny-slider/src/tiny-slider').tns;
    window.CountUp = require('countup.js').CountUp;
    require('jquery-circle-progress');
    require('jquery-validation');
    require('jquery-validation/dist/localization/messages_it.js');
    require('@tarekraafat/autocomplete.js');
    window.intlTelInput = require('intl-tel-input');
    require("select2");
    const ItalianSelect2Language = require('select2/src/js/select2/i18n/it');
    $.fn.select2.defaults.set('debug', true);
    $.fn.select2.defaults.set('language', ItalianSelect2Language);
    // tnx jQuery 3.6.0 + select2 4: @see https://stackoverflow.com/questions/25882999/set-focus-to-search-text-field-when-we-click-on-select-2-drop-down
    $(document).on('select2:open', () => {
        document.querySelector('.select2-search__field').focus();
    });
    window.Readmore = require('readmore-js').default;
    window.Cookies = require('js-cookie');

    // FIX: bootstrap 5 cambia l'url
    $('a[data-bs-toggle="collapse"]').on('click', '*', e => e.preventDefault())


} catch (e) { console.log(e) }

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
